import { render, staticRenderFns } from "./default.vue?vue&type=template&id=4c211d1c&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=4c211d1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('C:/Users/Administrator/Desktop/meccle/nuxt-pc/components/Footer/index.vue').default,BackTop: require('C:/Users/Administrator/Desktop/meccle/nuxt-pc/components/BackTop/index.vue').default})
